function CollectionPage() {
  const storeURL = 'https://glassalchemy.com';
  
  var selectors = {
    mainMenuSelector: '.rd-nav li',
    collectionHeader: '.collection-header',
    heading: '.heading',
    description: '.description',
    boostFilterButton: '.boost-pfs-filter-button',
    boostProductList: '.boost-pfs-filter-products',
    boostProductItem: '.boost-pfs-filter-product-item',
    boostProductImageLink: '.boost-pfs-filter-product-item-image-link',
    boostProductTitleLink: '.boost-pfs-filter-product-item-title',
    
    stockNotice: '.stock-notice-wrapper',
    
    boostFamilyFilterString: 'pf_t_family',
    boostTypeFilterString: 'pf_t_product_type',
    boostStockFilterString: 'pf_st_stock',
    
    collectionData: '#collection-data',
    
    searchField: '.boost-pfs-search-form input[type="search"]'
  };
  
  
  var familyNameMap = {
    "First-Gen": "first-gens",
    "Classic": "classic-palette",
    "Next-Gen": "next-gens",
    "Test Lab": "thomas-test-lab",
    "Sale": "we-love-our-customers-sale",
  }
  
  var collectionData;
  
  var publicMethods = {};
    
 
  async function fetchCollectionData() {
	let $data = $(selectors.collectionData);
    
    if ($data.length) {
      let data = JSON.parse($data.html());
      collectionData = data;
    }
  }
  
  function setHeaderBackground(url) {
    if ($header && url) {
      $header.css('background-image', 'url(' + url + ')');
    }      
  }
  
  function clearHeaderBackground() {
    if ($header) {
      $header.css('background-image', '');
    }
  }
  
  function updateHeading(message) {
    if ($heading) {
      $heading.text('');
      $heading.text(message);
    }
  }
  
  function clearHeading() {
    if ($heading) {
      $heading.text('');
    }
  }
  
  function updateDescription(message) {
    if ($description) {
      $description.text('');
      $description.html(message);
    }
  }
  
  function clearDescription() {
    if ($description) {
      $description.text('');
    }
  }  
  
  function clearHeader() {
  	clearHeading();
  	clearDescription();
    clearHeaderBackground();
  }
  
  function showStockNotice() {
    if ($stockNotice) {
      $stockNotice.addClass('visible');
    }
  }
  
  function hideStockNotice() {
    if ($stockNotice) {
      $stockNotice.removeClass('visible');
    }
  }
  
  function updateFamilySelection(selectionName) {
    if (collectionData) {
      console.log(collectionData);
      let collection = collectionData[selectionName];
      if (collection) {
        updateHeading(collection.title);
        updateDescription(collection.description);
        setHeaderBackground(collection.image);
      }
    }
  }
  
  function getCurrentBoostParams() {
    if (BoostPFS && BoostPFS.Globals && BoostPFS.Globals.queryParams) {
      return BoostPFS.Globals.queryParams;
    } 
    return null;
  }
  
  function setupHeader(params) {
    let selections = [];
    var filterString;
    
   if (params[selectors.boostFamilyFilterString] && params[selectors.boostFamilyFilterString].length === 1) {
      filterString = params[selectors.boostFamilyFilterString][0];
      filterString = familyNameMap[filterString];
      selections.push(filterString);
    }
    
    if (params[selectors.boostTypeFilterString] && params[selectors.boostTypeFilterString].length === 1) {
      filterString ="type-" + params[selectors.boostTypeFilterString][0].toLowerCase();
      selections.push(filterString);
    }
    
    if (selections.length === 1) {
      updateFamilySelection(selections[0]);
    } else {
		updateFamilySelection('type-default');
//       clearHeader();     
    }
    
    if (params[selectors.boostStockFilterString]){
      showStockNotice();
    } else {
      hideStockNotice();
    } 
  }
  
  function updateProductUrls(params)  {
	var typeSelection, stockSelection;
    
    if (params[selectors.boostTypeFilterString] && params[selectors.boostTypeFilterString].length === 1) {
		typeSelection = params[selectors.boostTypeFilterString][0].toLowerCase();      
    }
    
    if (params[selectors.boostStockFilterString]) {
		stockSelection = 1;
    }
    
    if (typeSelection || stockSelection) {

      $(selectors.boostProductItem).each(function (i) {
        let $titleLink = $(this).find(selectors.boostProductTitleLink);
        let $imageLink = $(this).find(selectors.boostProductImageLink);
        
        let basePath = $titleLink.attr('href');

        let newURL = new URL(basePath, window.location.origin);

        if(typeSelection) {          
          newURL.searchParams.append('typeSelected', typeSelection);
        }

        if (stockSelection) {
          newURL.searchParams.append('inStockOnly', 1);
        }
                
        $titleLink.attr('href', newURL.toString());
        $imageLink.attr('href', newURL.toString());
      });                        

    }
  }
  
  function updateProductVariantImage(params) {
	var typeSelection;

    if (params[selectors.boostTypeFilterString] && params[selectors.boostTypeFilterString].length === 1) {
		typeSelection = params[selectors.boostTypeFilterString][0].toLowerCase();      
    }    

    if (typeSelection === "frit") {
      jQ(".boost-pfs-filter-product-item").each(function(){
        var flipImageUrl = jQ(this).find('.boost-pfs-filter-product-item-main-image').data('img-frit');
        var flipImageSrcset= jQ(this).find('.boost-pfs-filter-product-item-main-image').data('img-frit-srcset');;

        if (flipImageUrl && flipImageSrcset) {
          var html = '<img class="boost-pfs-filter-product-item-flip-image lazyload Image--lazyLoad"' +
          'data-srcset="' + flipImageSrcset + '" ' +
          'data-src="' + flipImageUrl + '" ' +
          'data-widths="[180, 260, 360]" ' +
          'data-sizes="auto" ' +
          'src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" />';
          jQ(this).find('.boost-pfs-filter-product-item-image-link').prepend(html); 
        }
      });
    }
  }

  function handleBoostFilterClick() {
    let params = getCurrentBoostParams();

    setupHeader(params);
    
    setActiveMenuItem(params);
    // Boost takes a second to update the product grid
    window.setTimeout(() => {
	  updateProductVariantImage(params);
      updateProductUrls(params)
    }, 500);
  }

  function handleBoostPaginationClick() {
    let params = getCurrentBoostParams();

    window.setTimeout(() => {
	  updateProductVariantImage(params);
      updateProductUrls(params)
    }, 500);
  }
  
  function setActiveMenuItem(params) {
    var filterString;
    if (params[selectors.boostFamilyFilterString] && params[selectors.boostFamilyFilterString].length === 1) {
      filterString = params[selectors.boostFamilyFilterString][0];
    }
    
    if (params[selectors.boostTypeFilterString] && params[selectors.boostTypeFilterString].length === 1) {
      filterString = params[selectors.boostTypeFilterString][0].toLowerCase();
	
    }
	
    if (filterString) {      
      filterString = '.menu-' + filterString.split(' ').join('-').toLowerCase();
      if ($(selectors.mainMenuSelector + filterString).length) {
        $(selectors.mainMenuSelector).removeClass('active');
        $(selectors.mainMenuSelector + filterString).addClass('active');
      } else {
        $(selectors.mainMenuSelector).removeClass('active');
        $(selectors.mainMenuSelector + '.menu-all').addClass('active');
      }
    } else {
      $(selectors.mainMenuSelector).removeClass('active');
      $(selectors.mainMenuSelector + '.menu-all').addClass('active');
    }
  }

  function initializeMenuSelection() {    
	setActiveMenuItem(getCurrentBoostParams());
  }

  function initializeListeners() {  
    $(document).on('click', selectors.boostFilterButton, function(e) {
      handleBoostFilterClick();
    });
    
    $(document).on('click', BoostPFS.Selector.pagination + " a", function(e) {
      handleBoostPaginationClick();
    });
  }

  function initializeSearchField() {
    if ($searchField) {
     $searchField.focus(); 
    }
  }

  function initializeSearchHeader() {
    const urlParams = new URLSearchParams(window.location.search);
    const pageTitle = urlParams.get('title');
	console.log(urlParams);
    if (pageTitle === "search") {
      updateHeading("Search");
    }
  }
  
  publicMethods.init = function() {
    $header = $(selectors.collectionHeader);
    $heading = $(selectors.collectionHeader + ' ' + selectors.heading);
    $description = $(selectors.collectionHeader + ' ' + selectors.description);
    $stockNotice = $(selectors.stockNotice);
    $searchField = $(selectors.searchField);
    
    initializeMenuSelection();
    initializeListeners();
    initializeSearchField();
	fetchCollectionData();
    handleBoostFilterClick();
    initializeSearchHeader();  
  }
  
  return publicMethods;
  
}


$(document).ready(function() {
  let template = $('head').attr('data-template');
  
  if (template == "search" || template == "collection") {
    let collectionPage = new CollectionPage();
  
    collectionPage.init();  
  }
  

});